import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzSubjectMenuRegistry = {
    core_authzSubject: {
        label: "Authz Subject",
        link: PAGE_URL.AUTHZ_SUBJECT_PAGE,
        key: PAGE_URL.AUTHZ_SUBJECT_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzSubjectMenuRegistry;
